<template lang="pug">
v-app
  WarningSelect(v-show="!estabelecimentoSelecionado")
  v-container(grid-list-xl, fluid, Poppins, v-show="estabelecimentoSelecionado")
    v-layout(row, wrap, v-if="estabelecimentoSelecionado && loading")
      v-flex.text-xs-center
        v-progress-linear(:indeterminate="true").ma-1
    v-layout(row, wrap, v-if="estabelecimentoSelecionado && list.length")
      v-flex(lg12)
        v-card.br-10.cardPadraoPagamentos.pa-3
          v-layout(row, wrap, areaDePagamentos)
            v-flex.dadoPagamento.mb-2.ml-1.mr-1(v-for="(pagamento, index) in list", :key="index", @click.stop="salvar(pagamento)")
              v-btn(icon, :disabled="waiting || loading")
                v-icon(color="primary") {{ pagamento.checked ? 'check_box' : 'check_box_outline_blank' }}
              label {{ pagamento.nome }}
  OnboardingFab(etapa="etapa_pagamento")

</template>

<script>
import _ from 'lodash';
import OnboardingFab from '@/components/OnboardingFab';
import WarningSelect from '@/components/WarningSelect';

export default {
  components:{
    WarningSelect,
    OnboardingFab,
  },
  data () {
    return {
      loading: false,
      waiting: false,
      pagamentos: [],
      pagamento: {},
    }
  },
  computed: {
    list () {
      return this.pagamentos;
    },
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    },
  },
  created () {
    window.getApp.$on("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  beforeDestroy() {
    window.getApp.$off("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  mounted(){
    this.onChangeEstabelecimento();
  },
  methods: {
    onChangeEstabelecimento(){
      console.log('CHANGE_ESTABELECIMENTO PAGAMENTO', this.estabelecimentoSelecionado)
      if(this.estabelecimentoSelecionado) {
        this.getFormasPagamentoEstabelecimento();
        this.getFormasPagamento();
      }
    },
    async getFormasPagamento () {
      const vm = this;
      try {
        vm.loading = true;
        const response = await vm.$axios.get('/forma-pagamento', {
          params: {
            estabelecimento_id: vm.estabelecimentoSelecionado.id,
            ativo: 1,
          },
        });
        vm.loading = false;
        vm.pagamentos = response.data;
        vm.getFormasPagamentoEstabelecimento();
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar as formas de pagamento. Atualize a página!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },

    async getFormasPagamentoEstabelecimento () {
      const vm = this;
      try {
        if (!vm.estabelecimentoSelecionado) return;
        if (!vm.pagamentos.length) return vm.getFormasPagamento();
        vm.loading = true;
        const response = await vm.$axios.get('/forma-pagamento-estabelecimento', {
          params: {
            estabelecimento_id: vm.estabelecimentoSelecionado.id
          }
        });
        vm.loading = false;
        const pagamentos = _.cloneDeep(vm.pagamentos);
        pagamentos.map(pagamento => {
          pagamentos.checked = false;
          response.data.map(obj => {
            if (pagamento.id == obj.forma_pagamento_id) {
              pagamento.forma_pagamento_id = obj.id;
              pagamento.checked = true;
            }
          });
        });
        vm.pagamentos = pagamentos;
        vm.pagamento_id = true;
        vm.loading = false;
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar as formas de pagamento. Atualize a página!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async salvar (pagamento) {
      const vm = this;
      if(vm.waiting || vm.loading) return
      vm.waiting = true
      try {
        pagamento.checked = !pagamento.checked;
        if (!pagamento.checked && _.filter(vm.pagamentos, o => o.checked).length === 0){
          if (vm.estabelecimentoSelecionado.pagamento_online) {
            const confirmado = await vm.$confirm(
              'Todas as formas de pagamento offline serão desativadas. A loja ficará apenas com pagamento online. Confirma?',
              { title: 'Atenção', color: 'warning' }
            );
            if (!confirmado) {
              pagamento.checked = true;
              vm.waiting = false;
              return;
            }
          } else {
            pagamento.checked = true;
            vm.waiting = false;
            return window.getApp.$emit('APP_ALERT', { color: 'red', text: 'É necessário pelo ter menos 1 forma de pagamento selecionada!' });
          }
        }
        const response = await vm.$axios[pagamento.checked ? 'post' : 'delete']('/forma-pagamento-estabelecimento', pagamento.checked ? {estabelecimento_id: vm.estabelecimentoSelecionado.id, pagamento: [pagamento] } : { params: { id: pagamento.forma_pagamento_id } } );
        const pagamentos = _.cloneDeep(vm.pagamentos);
        pagamentos.map(pg => {
          if (pg.id == pagamento.id)
            pg.forma_pagamento_id = pagamento.checked ? response.data.id : null;
        });

        vm.pagamentos = pagamentos;
        window.getApp.$emit('APP_ALERT', { color: 'green', text: "Pagamento salvo com sucesso!" });
        vm.waiting = false
      } catch (error) {
          console.log(error)
        let err = error.response && error.response.data ? error.response.data.error : 'Erro ao salvar pagamento. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.waiting = false
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.Poppins{
    font-family: "Poppins", "Roboto", "Helvetica";
  }
  .Captalize{
    text-transform: capitalize !important;
  }
  .conteudo {
    min-height: 100px;
    height: 100px;
  }
  .br-5{
      border-radius: 5px !important;
  }
  .br-10{
      border-radius: 10px !important;
  }
  .cardPadrao{
    box-shadow:none !important;
    background-color: transparent;
  }
  .cardPadraoPagamentos{
    box-shadow:none !important;
    background-color: transparent;
    margin-bottom: 25px;
  }
  .areaDePagamentos{
    padding: 5px;
    display: flex;
    place-items: stretch;
    place-content: space-between center;
    justify-content: space-evenly;
  }
  .dadoPagamento{
    max-width: 32%;
    min-width: 300px;
    width: 32%;
    background-color: #fff;
    border: 1px solid rgba(17, 19, 18, 0.2);
    border-radius: 16px;
    cursor: pointer;
  }
  @media (max-width: 750px){
  .dadoPagamento{
    max-width: 100%;
  }
}
</style>
